export default (fill) => (
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 137.2">
    <path fill="#D0E0E1"
          d="M0 12.5C0 5.6 5.6 0 12.5 0h54L100 34.1l-.3 90.7c0 6.9-5.6 12.5-12.5 12.5H12.5c-6.9 0-12.5-5.6-12.5-12.5V12.5z"/>
    <g fill="#6D7577">
        <path d="M28.8 88.8c2.5 0 4.4.6 5.6 1.9 1.3 1.3 1.9 3.1 1.9 5.4 0 2.3-.6 4.1-1.9 5.4-1.3 1.3-3.2 1.9-5.6 1.9h-7.5v10.1H18V88.8h10.8zm-1.1 11.8c1.9 0 3.2-.4 4.1-1.1.9-.8 1.3-1.9 1.3-3.4s-.4-2.6-1.3-3.4c-.9-.8-2.2-1.2-4.1-1.2h-6.4v9h6.4zM48.8 88.8c3.8 0 6.7 1 8.8 2.9 2 1.9 3.1 4.9 3.1 8.8 0 2.1-.2 3.9-.7 5.5s-1.2 2.9-2.1 4c-1 1.1-2.2 1.9-3.7 2.5s-3.3.9-5.3.9h-8.4V88.8h8.3zm.3 21.9c.4 0 .8 0 1.4-.1s1.1-.2 1.8-.4c.6-.2 1.2-.5 1.8-.9.6-.4 1.2-1 1.6-1.7s.9-1.6 1.2-2.7c.3-1.1.5-2.4.5-3.9s-.1-2.8-.4-3.9c-.3-1.2-.8-2.1-1.4-3-.7-.8-1.5-1.4-2.5-1.9-1-.4-2.3-.6-3.8-.6h-5.5v19.1h5.3zM80.8 88.8v2.8H67.9v7.8h11.3v2.8H67.9v11.3h-3.3V88.8h16.2z"/>
    </g>
    <path fill="${fill ? fill : '#A1AFAF'}" d="M66.5 0v34.1H100L66.5 0z"/>
  </svg>`
)



// WEBPACK FOOTER //
// ./components/Icon/icons/files/pdf.jsx